import { safeParse } from "../../../utility/utility";

export default {
  getCurrentUser(state) {
    return state.currentUser;
  },

  getResErr(state) {
    return state.resErr;
  },

  getUserRole() {
    let getCurrent = localStorage.getItem("currentUser");
    if (getCurrent) {
      let userRole = safeParse(getCurrent);
      return userRole?.role || "";
    }
    return "";
  },

  getIsAdmin(state) {
    return state.isAdmin;
  },
  getCurrent(state) {
    return state.currentUserData;
  },
};
